import { LitEntity, html } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import './work-order-admin-view';

class WorkOrderAdminShow extends LitEntity {
  static get styles () {
    return sharedStyles;
  }

  renderEntity() {
    const { referenceId } = this.entity.properties;

    return html`
      <h1>Work Order: ${referenceId}</h1>
      <work-order-admin-view .href="${this.href}"></work-order-admin-view>
    `;
  }
}

customElements.define('work-order-admin-show', WorkOrderAdminShow);
